import gql from 'graphql-tag';
import React from 'react';
import { useState } from 'react';
import { Fragment } from 'react';
import { withApollo } from 'react-apollo';
import callIcon from '../../images/callrequest-icon.svg';
import SignUpCallRequestCancelled from './SignUpCallRequestCancelled';

const SignUpCallRequest = ({ client, ticketId, requestId }) => {
  const [isCancel, setisCancel] = useState();

  const toggleCancell = () => {
    setisCancel(!isCancel);
  };

  const CANCEL_CALL = gql`
    mutation CancelCallRequest($ticketId: ID!, $requestId: ID!) {
      cancelCallRequest(ticketId: $ticketId, requestId: $requestId) {
        callRequest {
          id
        }
        success
        error
      }
    }
  `;

  const handleCancelCall = () => {
    // e.preventDefault();
    client
      .mutate({
        mutation: CANCEL_CALL,
        variables: {
          ticketId: ticketId,
          requestId: requestId
        }
      })
      .then(res => {
        console.log(res.data.cancelCallRequest);
        if (res.data.cancelCallRequest.success) {
          toggleCancell();
          console.log('Call request cancelled');
        }
      });
  };

  const isMobile = window.innerWidth < 768;

  return (
    <Fragment>
      {isCancel ? (
        <SignUpCallRequestCancelled />
      ) : (
        <div
          className="signup-form-container"
          style={{ alignItems: 'center' }}>
          <img
            src={callIcon}
            style={{ width: '72px', marginBottom: '36px' }}
          />
          <div className="form-title" style={{ fontSize: '40px' }}>
            Sit tight...
          </div>
          <div
            className="download-description"
            style={{
              fontSize: isMobile ? '16px' : '20px',
              margin: '24px 0 56px 0'
            }}>
            Our team has received your call request. We will call you soon.
          </div>
          <button
            className="signup-button-reverse"
            onClick={() => {
              handleCancelCall();
            }}>
            Cancel request
          </button>
        </div>
      )}
    </Fragment>
  );
};

export default withApollo(SignUpCallRequest);



// WEBPACK FOOTER //
// ./src/components/NewSignUp/SignUpCallRequest.js